import styled from 'styled-components';
import { Button } from 'antd';

export const RetryWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ErrorOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgb(255 255 255 / 90%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  font-size: 14px;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgb(255 255 255 / 80%);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);
  border-radius: 8px;
  z-index: 5;
`;

export const ActionButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    transform: translateY(-1px);
  }
`;

export const ContactButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ff4d4f;
  border-color: #ff4d4f;

  &:hover {
    color: #ff7875;
    border-color: #ff7875;
    transform: translateY(-1px);
  }
`;
